module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-left-dots-fill-c2869d9a.svg";